import { useCallback, useEffect, useState } from "react";
import "./BlogCategories.css";
import { Link } from "react-router-dom";
import api from "../../../../api/axiosInstance";
import { DictionaryItem } from "../../DictionaryPage/DictionaryPage";
import Search from "../Search/Search";

const BlogCategories = () => {
  const [items, setItems] = useState<DictionaryItem[]>([]);

  const fetchItems = useCallback(async () => {
    const response = await api.get(`Dictionary/Category`);
    setItems(response.data);
  }, []);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  return (
    <div
      className="md:flex bg-white rounded-3xl xl:rounded-full p-4 shadow-lg items-center justify-center gap-8"
      style={{
        minWidth: "12rem",
      }}
    >
      <div className="flex-1 flex items-center justify-start flex-wrap gap-2">
        <Link
          to="/blog/posts"
          className="button-transition bg-blue-800 hover:bg-blue-700 text-white rounded-2xl md:rounded-full px-4 py-2"
        >
          ყველა კატეგორია
        </Link>
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/blog/posts?category=${item.categoryName}`}
            className="button-transition hover:bg-blue-50 rounded-full px-4 py-2"
          >
            {item.categoryName}
          </Link>
        ))}
      </div>
      <span className="hidden md:inline text-xl font-medium">|</span>
      <Search />
    </div>
  );
};

export default BlogCategories;
